<template>
  <div class="main-container">


    <v-row justify="center" align="start">
      <v-col cols="12" md="12" class="pa-0">
        <v-card elevation="3" class="report-bug-card" style="margin-top:200px;">
          <h2 class="header">Report a Bug</h2>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-col class="pa-4">
                <v-row justify="center" cols="12" sm="6">
                  <v-text-field
                    v-model="fullName"
                    label="Full Name"
                    filled
                    rounded
                    dense
                    prepend-inner-icon="mdi-account"
                    class="montserrat-input"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-row>
                <v-row justify="center" cols="12" sm="8">
                  <v-textarea
                    v-model="description"
                    label="Bug Description"
                    filled
                    rounded
                    dense
                    prepend-inner-icon="mdi-bug"
                    class="montserrat-input"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-row>
                <v-row justify="center" cols="12" sm="4">
                  <v-btn outlined rounded large @click="triggerFileInput" class="montserrat-button my-3">
                    <v-icon left>mdi-camera</v-icon> Upload Photo
                  </v-btn>
                  <input
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    capture="camera"
                    @change="handleFileUpload"
                    style="display: none;"
                  />
                </v-row>
                <v-row justify="center" cols="12" sm="4" v-if="photos.length">
                  <v-btn outlined rounded large @click="viewPhotos" class="montserrat-button my-3">
                    <v-icon left>mdi-eye</v-icon> View Photos
                  </v-btn>
                </v-row>
              </v-col>
              <v-row v-if="photos.length">
                <v-col cols="12" sm="2" v-for="(photo, index) in photos" :key="index">
                  <v-img :src="photo" class="ma-2 photo-preview"></v-img>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn dark rounded large @click="submitReport" class="montserrat-button my-3">
                  <v-icon left>mdi-bug-check"></v-icon> Submit
                </v-btn>
              </v-row>
            </v-form>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary"
              size="70"
              class="my-4"
            ></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  addDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { firebaseApp } from "@/firebaseConfig";

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export default {
  data() {
    return {
      valid: false,
      fullName: "",
      description: "",
      photos: [],
      files: [],
      loading: false,
      rules: {
        required: value => !!value || 'Required.',
      },
    };
  },
  methods: {
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      this.photos = files.map(file => URL.createObjectURL(file));
      this.files = files;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    viewPhotos() {
      // Implement logic to view photos, e.g., opening a dialog with full-size images
    },
    async uploadFiles() {
      const fileUrls = await Promise.all(
        this.files.map(async file => {
          const storageRef = ref(storage, `bug_reports/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        })
      );
      return fileUrls;
    },
    async submitReport() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          const fileUrls = await this.uploadFiles();
          await addDoc(collection(db, "bugReports"), {
            fullName: this.fullName,
            description: this.description,
            photos: fileUrls,
            createdAt: new Date(),
          });
          this.$refs.form.reset();
          this.photos = [];
          this.files = [];
        } catch (error) {
          console.error("Error submitting bug report:", error);
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.main-container {
  background-color: #121212;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.report-bug-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.header {
  text-align: center;
  color: #ff3b47;
  font-weight: bold;
}

.montserrat-input {
  font-family: "Montserrat", sans-serif;
}

.montserrat-button {
  font-family: "Montserrat", sans-serif;
}

.photo-preview {
  height: 100px;
  width: 100px;
  border-radius: 8px;
}
</style>
